import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle, faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import { Link } from 'react-router-dom'

const ClaimConfirmation = ({policy}) => {
  return (
    <div className="mx-auto px-8 text-center">
      {/* <div className="flex w-1/3 text-center items-center justify-start">
        <Link
          to="/sai/claims"
          className="inline-flex items-center border border-sas text-sas rounded-md overflow-hidden hover:border-2"
        >
          <span className="pl-2">
            <FontAwesomeIcon icon={faArrowLeft} />
          </span>
          <span className="px-4 py-2 text-sm font-medium">
            Go Back to Claims
          </span>
        </Link>
      </div> */}

      <h2 className="text-2xl font-semibold mb-4">Thank you</h2>
      <FontAwesomeIcon
        icon={faCheckCircle}
        className="text-sas text-6xl mb-4"
      />

      <p className="text-gray-700 mb-6">
        Thank you for submitting your {policy.department === 'Mutual' ? 'Payment Request' : 'Claim'} for consideration
      </p>

      <div className="bg-red-600 text-white text-sm px-4 py-3 rounded-md">
        <p className="font-semibold">Action Required</p>
        <p className="text-xs">
          This {policy.department === 'Mutual' ? 'Payment Request' : 'Claim'} requires further information before it can be
          processed.{' '}
          <a href="/claims" className="underline">
            Click here to action this request
          </a>
        </p>
      </div>
    </div>
  )
}

export default ClaimConfirmation
